import { Component, OnInit } from '@angular/core';
 
import { ProjectDrawingUploadComponent } from '../project-drawing-upload/project-drawing-upload.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-project-drawing',
  templateUrl: './project-drawing.component.html',
  styleUrls: ['./project-drawing.component.css']
})
export class ProjectDrawingComponent implements OnInit {

  constructor(  private dialog: MatDialog) { }

  ngOnInit(): void {
  }
 

  openDrawingUpload() {
   this.dialog.open(ProjectDrawingUploadComponent);
 }
}
